import i18n from 'i18next';
import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { pageUrls } from 'globalconfig/constants/keys';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ provider }) => {
  return {
    hasLinkAccessText: {
      [SERVICE_PROVIDERS.SPIREON]: () => 'Please go back to',
      default: () => i18n.t('send feedback'),
    },
    hasLinkAccessHref: {
      [SERVICE_PROVIDERS.SPIREON]: () => pageUrls.dashboard,
      default: () => pageUrls.feedback,
    },
    hasLinkAccessLabel: {
      [SERVICE_PROVIDERS.SPIREON]: () => 'Summary',
      default: () => i18n.t('here'),
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
